import React, { useState } from 'react';
import { PDFDocument } from 'pdf-lib';

export const RepairPdfView: React.FC = () => {
  const [file, setFile] = useState<File | null>(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);

  const handleRepair = async () => {
    if (!file) {
      setError("Please select a corrupted PDF file.");
      return;
    }
    setIsProcessing(true);
    setError(null);
    setSuccess(null);
    try {
      const arrayBuffer = await file.arrayBuffer();
      // throwOnInvalidObject: false allows pdf-lib to ignore structural errors and reconstruct the cross-reference table
      const pdf = await PDFDocument.load(arrayBuffer, { throwOnInvalidObject: false });
      
      const pdfBytes = await pdf.save();
      const blob = new Blob([pdfBytes as unknown as BlobPart], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `repaired_${file.name}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      setSuccess("File successfully processed and reconstructed.");
    } catch (err: unknown) {
      if (err instanceof Error && err.message.includes('encrypted')) {
        setError("This file is encrypted. Please provide a decrypted file.");
      } else {
        setError(err instanceof Error ? err.message : String(err));
      }
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, padding: '1rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <div>
          <h2 style={{ margin: 0 }}>Repair PDF</h2>
          <p style={{ margin: '0.25rem 0 0', color: 'var(--color-text-secondary)' }}>Attempt to recover corrupted PDFs by reconstructing broken cross-reference tables.</p>
        </div>
        <button onClick={() => { void handleRepair(); }} disabled={isProcessing} style={{ padding: '0.5rem 1rem', background: 'var(--color-accent)', color: 'var(--color-on-accent)', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 600 }}>
          {isProcessing ? 'Repairing...' : 'Repair File'}
        </button>
      </div>
      {error && <div style={{ color: 'red', marginBottom: '1rem', padding: '0.5rem', background: '#ffebee', borderRadius: '4px' }}>{error}</div>}
      {success && <div style={{ color: 'green', marginBottom: '1rem', padding: '0.5rem', background: '#e8f5e9', borderRadius: '4px' }}>{success}</div>}
      
      <div style={{ flex: 1, border: '2px dashed var(--color-border)', borderRadius: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '2rem' }}>
        <input 
          type="file" 
          accept="application/pdf" 
          onChange={(e) => {
            const file = e.target.files?.[0];
            if (file) {
              setFile(file);
              setError(null);
              setSuccess(null);
            }
          }}
          style={{ marginBottom: '1rem' }}
        />
        {file && (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
            <span>{file.name}</span>
          </div>
        )}
      </div>
    </div>
  );
};
